import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const selectLoadingState = createFeatureSelector<State>('loading');

export const getLoadingKeys = createSelector(
    selectLoadingState,
    (state: State): string[] => state.loadingKeys
);

export const isLoading = createSelector(
    selectLoadingState,
    (state: State): boolean => state.loadingKeys.length !== 0
);
